<template>
  <!-- One of the small outline glyphs (utils/trailHazards/hazardIcons.ts: the
       tick and the clock), drawn inline so it takes any colour. Hazard TYPE
       icons are HazardTypeIcon (the sprite's triangles). -->
  <svg
    class="hazard-icon"
    :width="size"
    :height="size"
    :viewBox="`0 0 ${viewBox} ${viewBox}`"
    fill="none"
    :stroke="color"
    :stroke-width="icon.strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path v-for="(d, index) in icon.paths" :key="index" :d="d" />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { HAZARD_ICON_VIEWBOX } from '../../../utils/trailHazards/hazardIcons';
import type { HazardIconDef } from '../../../utils/trailHazards/hazardIcons';

export default defineComponent({
  name: 'HazardIcon',
  props: {
    icon: { type: Object as PropType<HazardIconDef>, required: true },
    size: { type: Number, default: 20 },
    color: { type: String, default: 'currentColor' },
  },
  setup() {
    return { viewBox: HAZARD_ICON_VIEWBOX };
  },
});
</script>

<style scoped>
.hazard-icon {
  flex: 0 0 auto;
  display: block;
}
</style>
